module.exports = "<p>\n  {{batch_id}} - {{data?.status}}\n</p>\n"